module.exports = __webpack_public_path__ + "img/country_mokka_ba_list.72b5c559.jpg";